(function () {
  'use strict';

  function VideoLightbox(targets) {
    if (!targets) throw new Error('Missing selector 😢');

    let elements;

    if (typeof targets === 'string') {
      elements = Array.prototype.slice.call(document.querySelectorAll(targets));
    } else if (typeof targets === 'object') {
      elements = Array.prototype.slice.call(targets);
    }

    elements.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();

        // close any open lightboxes
        closeLightboxes();

        let videoUrl = element.href;
        let cookie = util.getCookie('cookieconsent_other');

        // create lightbox
        const lightbox = document.createElement('div');
        lightbox.classList.add('videoLightbox');

        // create close button
        const closeButton = document.createElement('a');
        closeButton.classList.add('videoLightbox__close');
        closeButton.setAttribute(
          'aria-label',
          element.dataset.closeLabel ?? 'Close lightbox'
        );
        closeButton.href = '#';
        closeButton.innerHTML =
          '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">' +
          '<path fill="currentColor" d="M26.286 3.836c-0.482 0-0.963 0.183-1.329 0.549l-20.572 20.572c-0.733 0.733-0.733 1.925 0 2.659s1.925 0.733 2.659 0l20.572-20.572c0.733-0.733 0.733-1.925 0-2.659-0.367-0.367-0.848-0.549-1.329-0.549z"></path>' +
          '<path fill="currentColor" d="M5.714 3.833c-0.499 0-0.977 0.2-1.329 0.552-0.733 0.733-0.733 1.925 0 2.659l20.572 20.572c0.733 0.733 1.925 0.733 2.659 0s0.733-1.925 0-2.659l-20.572-20.572c-0.353-0.353-0.831-0.552-1.329-0.552z"></path>' +
          '</svg>';

        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          closeLightboxes();
        });

        // create lightbox inner
        const lightboxInner = document.createElement('div');
        lightboxInner.classList.add('videoLightbox__inner');

        // show message when cookie consent has not been given
        if (cookie === 'accepted') {
          const lightboxVideo = document.createElement('div');
          lightboxVideo.setAttribute('role', 'dialog');
          lightboxVideo.classList.add('videoLightbox__video');
          lightboxVideo.innerHTML = getVideoEmbedHtmlFromUrl(videoUrl);
          lightboxInner.appendChild(lightboxVideo);
        } else {
          const lightboxCookie = document.createElement('div');
          lightboxCookie.setAttribute('role', 'dialog');
          lightboxCookie.classList.add('videoLightbox__cookie');
          lightboxCookie.classList.add('is-content');
          lightboxCookie.innerHTML =
            element.dataset.cookieConsent ??
            'Hier wordt een video ingeladen. We mogen deze video echter alleen tonen als u toestemming geeft voor het plaatsen van social media cookies. <a href="#" onclick="app.cookiePopup.open();return false;">Pas uw instellingen aan</a> en open de video opnieuw.';
          lightboxInner.appendChild(lightboxCookie);
        }

        const body = document.querySelector('body');

        // add lightbox to DOM
        lightbox.appendChild(closeButton);
        lightbox.appendChild(lightboxInner);

        body.classList.add('videoLightbox--open');
        body.appendChild(lightbox);

        // focus on close button
        closeButton.focus();
      });
    });

    function closeLightboxes() {
      const lightboxes = document.querySelectorAll('.videoLightbox');
      if (lightboxes) {
        lightboxes.forEach((lightbox) => {
          lightbox.remove();
        });
      }

      const body = document.querySelector('body');
      body.classList.remove('videoLightbox--open');
    }

    function getVideoEmbedHtmlFromUrl(url) {
      var patternYouTube =
        /(?:http|https)?:\/\/(?:www\.)?(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/g;
      var patternVimeo =
        /(?:http|https)?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|)(\d+)(?:|\/\?)/g;
      var html = '#';

      // YouTube
      if (patternYouTube.test(url)) {
        html = url.replace(
          patternYouTube,
          "<iframe width='1280' height='720' src='//www.youtube-nocookie.com/embed/$1?rel=0&autoplay=1&showinfo=0' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
        );
      }

      // Vimeo
      if (patternVimeo.test(url)) {
        html = url.replace(
          patternVimeo,
          "<iframe width='1280' height='720' src='//player.vimeo.com/video/$1?autoplay=1&dnt=1' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
        );
      }

      return html;
    }

    return {
      closeLightboxes: closeLightboxes,
    };
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = VideoLightbox;
  } else {
    window.VideoLightbox = VideoLightbox;
  }
})();
